export enum ButtonSize {
  Small = 'small',
  Middle = 'middle',
  Large = 'large',
}
